import {useTranslation} from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import NewGrid from "../newGrid/NewGrid";
import DarkLightSwitch from "../DarkLightSwitch/DarkLightSwitch";
import AboutMe from "./AboutMe";
import MyProjects from "./MyProjects";
import Studies from "./Studies";
import OtherData from "./OtherData";
import WorkExperience from "./WorkExperience";
import {useRef} from "react";
import Section from "./Section";
import Stack from "./Stack";
import Skills from "./Skills";

type Props = {
    darkMode: boolean
    openModal: () => void
    toggleDarkMode: () => void
}

const Presentation = (props: Props) => {
    const {t} = useTranslation();
    const stackRef = useRef(null);
    const myProjectsRef = useRef(null);
    const studiesRef = useRef(null);
    const workExperienceRef = useRef(null);
    const otherDataRef = useRef(null);
    const skillsRef = useRef(null);
    return (
        <div className={"flex flex-col items-center w-full overflow-hidden"}>
            <header
                className={"sticky top-0 z-30 w-full border-b border-borderLight dark:border-borderDark " +
                    "bg-bgLight/90 dark:bg-bgDark/90 backdrop-blur supports-[backdrop-filter]:bg-bgLight/75 " +
                    "dark:supports-[backdrop-filter]:bg-bgDark/75"}>
                <div className={"mx-auto flex h-14 max-w-3xl items-center justify-between px-4 sm:px-6 " +
                    "lg:max-w-5xl"}>
                    <div className={"flex min-w-0 flex-col leading-tight"}>
                        <span className={"truncate text-sm font-bold tracking-tight"}>Jaime José Corral García</span>
                        <span className={"hidden truncate text-xs text-mutedLight dark:text-mutedDark sm:block"}>
                            {t("presentation.desc")}
                        </span>
                    </div>
                    <div className={"flex shrink-0 items-center gap-3"}>
                        <DarkLightSwitch darkMode={props.darkMode} toggleDarkMode={props.toggleDarkMode}/>
                        <LanguageSwitcher/>
                    </div>
                </div>
            </header>

            <main className={"flex w-full flex-col items-center px-4 sm:px-6"}>
                <div className={"mt-6 w-full max-w-3xl lg:max-w-5xl"}>
                    <AboutMe openModal={props.openModal}/>
                </div>

                <div className={"mt-6 w-full max-w-3xl lg:max-w-5xl"}>
                    <NewGrid stackRef={stackRef} myProjectsRef={myProjectsRef}
                             studiesRef={studiesRef} workExperienceRef={workExperienceRef}
                             otherDataRef={otherDataRef} skillsRef={skillsRef}/>
                </div>

                <div className={"mt-10 flex w-full max-w-3xl flex-col gap-6 lg:max-w-5xl lg:gap-10"}>
                    <div ref={workExperienceRef} className={"w-full scroll-mt-20"}>
                        <Section title={t('workExperience.title')}>
                            <WorkExperience/>
                        </Section>
                    </div>
                    <div ref={myProjectsRef} className={"w-full scroll-mt-20"}>
                        <Section title={t("projects.myProjects")}>
                            <MyProjects/>
                        </Section>
                    </div>
                    <div ref={stackRef} className={"w-full scroll-mt-20"}>
                        <Section title={t('stack.title')}>
                            <Stack/>
                        </Section>
                    </div>
                    <div ref={skillsRef} className={"w-full scroll-mt-20"}>
                        <Section title={t("skills.title")}>
                            <Skills/>
                        </Section>
                    </div>
                    <div ref={studiesRef} className={"w-full scroll-mt-20"}>
                        <Section title={t('studies.title')}>
                            <Studies/>
                        </Section>
                    </div>
                    <div ref={otherDataRef} className={"w-full scroll-mt-20"}>
                        <Section title={t('otherData.title')}>
                            <OtherData/>
                        </Section>
                    </div>
                </div>

                <footer className={"mt-12 w-full border-t border-borderLight dark:border-borderDark py-6 text-center"}>
                    <p className={"text-sm text-mutedLight dark:text-mutedDark"}>
                        Jaime José Corral García · Ferrol, A Coruña
                    </p>
                </footer>
            </main>
        </div>
    )
}

export default Presentation
